import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Location } from '@angular/common';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.scss']
})

export class AccessComponent implements AfterViewInit, OnInit {

  username: string;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private _location: Location) { }

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  goBack() {
    this._location.back();
  }

  search(){
  }
}